import * as NUMBER from 'constant/number'
import React from 'react'
import { Modal, Switch, Avatar, Row, Col } from 'antd'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { updateEmailPreference, updateLocationPreference } from 'action/user'
import Loader from 'view/component/loader'
import _ from 'lodash'
import classnames from 'classnames'
import styles from './index.scss'

const onChange = (preference, uuid, updatePreference) => {
  updatePreference(preference, uuid)
}

const Settings = ({ inPlcp, isModalVisible, handleClose, user, updateEmailPreference, loading, possibleSites, updateLocationPreference }) => {
  let src = 'https://analytics.premierleague.com/qlikauthenticate/content/Team Logos/premier_league.png'
  if (user.organisations.length === NUMBER.ONE) {
    const userOrg = _.snakeCase(user.organisations[NUMBER.ZERO].name)
    const userOrgVaildated = userOrg.replace(/\W+/g, '')
    src = `https://analytics.premierleague.com/qlikauthenticate/content/Team Logos/${userOrgVaildated}.png`
  } else {
    const organisation = user.organisations.find((org, index) => {
      if (org.name === premierLeagueUser || org.name === EFLUser) {
        return true
      } else {
        return false
      }
    })
    if (organisation.name === premierLeagueUser) {
      src = 'https://analytics.premierleague.com/qlikauthenticate/content/Team Logos/premier_league.png'
    } else {
      src = `https://analytics.premierleague.com/qlikauthenticate/content/Team Logos/${organisation.name}.png`
    }
  }
  return (
    <Modal
      bodyStyle={{ paddingLeft: '10px' }}
      cancelButtonProps={{ style: { display: 'none' } }}
      centered
      className={styles.settingModal}
      okText='Close'
      onCancel={handleClose}
      onOk={handleClose}
      title={getUserInfo(user)}
      visible={isModalVisible}
      width={500}
    >
      <div>{getMiddleSection(user, updateEmailPreference, loading, src, updateLocationPreference, inPlcp)}</div>
      {!inPlcp && <div>{getSites(possibleSites)}</div>}
    </Modal>

  )
}

const getMiddleSection = (user, updateEmailPreference, loading, src, updateLocationPreference, inPlcp) => {
  return (<>
    {!inPlcp &&
     <div className={classnames('d-flex justify-content-between', styles.toggles)}>
       <span className={styles.sub_text}>Allow Emails</span>
       {loading
          ? <Loader relative />
          : <>
            <Switch
              defaultChecked={user.send_email}
              onChange={(e) => onChange(e, user.uuid, updateEmailPreference)}
            />
          </>
       }
     </div>}
    <div className={classnames('d-flex justify-content-between', styles.toggles)}>
      <span className={styles.sub_text}>Allow Location Cookies</span>
      {loading
          ? <Loader relative />
          : <>
            <Switch
              defaultChecked={user.location_tracking}
              onChange={(e) => onChange(e, user.uuid, updateLocationPreference)}
            />
          </>
      }
    </div>
    {!inPlcp &&
    <>
      <span className={classnames('d-flex justify-content-between pb-0', styles.toggles, styles.name_text)}>Organisation</span>
      <div className={classnames('d-flex justify-content-between pt-0', styles.toggles)}>
        <span className={styles.sub_text}>{getOrg(user.organisations)}</span>
        <img
          className={styles.organisation_avatar}
          src={src}
        />
      </div>
    </>
    }
  </>
  )
}

const premierLeagueUser = 'Premier League'
const EFLUser = 'EFL'

const getOrg = (organisations) => {
  if (organisations.length > NUMBER.ONE) {
    const organisation = organisations.find((org, index) => {
      if (org.name === premierLeagueUser || org.name === EFLUser) {
        return true
      } else {
        return false
      }
    })
    return organisation.name
  } else {
    return organisations[0].name
  }
}
const getUserInfo = (user) => {
  return (
    <>
      <h5 className={styles.title}>User Profile</h5>
      <Row>
        <Col md={3}>
          <Avatar
            className={styles.username}
            shape='square'
            size={50}
          >
            {user ? `${user.first_name[NUMBER.ZERO].toUpperCase()}${user.last_name[NUMBER.ZERO].toUpperCase()}` : 'U'}
          </Avatar>
        </Col>

        <Col
          className={'px-2'}
          md={21}
        >
          <p className={classnames(styles.sub_text, styles.purple)}>{user.first_name} {user.last_name}</p>
          <p className={styles.email_text}>{user.email}</p>
        </Col>
      </Row>

    </>
  )
}

const getSites = (possibleSites) => {
  return (<>
    <span className={classnames('d-flex justify-content-between pb-0', styles.toggles, styles.name_text)}>Sites</span>
    <div className={styles.toggles}>
      <span>{possibleSites.map((site, index) => {
        return (
          <div
            className={classnames('d-flex justify-content-between py-1 pt-0')}
            key={index}
          >
            <p
              className={styles.sub_text}
            >{site.site_name}</p>
            <img
              className={styles.site_icon}
              src={site.icon}
            />
          </div>)
      })}</span>

    </div>
  </>
  )
}
Settings.propTypes = {
  handleClose: PropTypes.func,
  inPlcp: PropTypes.bool,
  isModalVisible: PropTypes.bool,
  loading: PropTypes.bool,
  possibleSites: PropTypes.array,
  updateEmailPreference: PropTypes.func,
  updateLocationPreference: PropTypes.func,
  user: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    loading: state.loader.loading,
    possibleSites: state.site.possibleSites,
    user: state.auth.user
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateEmailPreference: bindActionCreators(updateEmailPreference, dispatch),
  updateLocationPreference: bindActionCreators(updateLocationPreference, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
